




























import router from '@/router'
import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({
  components: {},
})
export default class Menu extends Vue {

  @Prop() drawerWidth: number
  @Prop() currentMenu: string

  // @Prop() onClickMenu: Function

  onClickMenu(path: string) {
    router.push('/' + path)
  }

}

